export const CanRiskResultRecipe = {
    $type$: 'Recipe',
    name: 'CanRiskResult',
    rule: [
        {
            itemprop: 'ownerIdHash', // patientId
            itemtype: { type: 'referenceToId', allowedTypes: new Set(['Person']) }
        },
        {
            itemprop: 'questionnaireResponsesHash',
            itemtype: { type: 'referenceToObj', allowedTypes: new Set(['QuestionnaireResponses']) },
            optional: true
        },
        {
            itemprop: 'result',
            itemtype: { type: 'string' }
        }
    ]
};
const CanRiskRecipes = [CanRiskResultRecipe];
export default CanRiskRecipes;
//# sourceMappingURL=CanRiskResultRecipe_1_0_0.js.map